export function getOffset(offsets, frameIndex) {
    return offsets == null ? null : offsets[frameIndex] | 0;
}
